import React from 'react';
import ManagerInfo from '.';
import { RiderType } from 'models/rider.model';

type RiderProps = {
  count: number;
  managers: RiderType[];
};

const Managers = ({ count, managers }: RiderProps) => {
  return (
    <div className='border border-[#E9EBEC] px-8 py-10 rounded-lg'>
      <div>
        <p className='font-medium text-xl mb-6 md:text-2xl'>Managers({count})</p>
      </div>
      <div>
        <ManagerInfo managers={managers} />
      </div>
    </div>
  );
};

export default Managers;
